import { Component, Input, OnInit } from '@angular/core';
import { LsnErrorStateMatcher } from '../../../shared/middleware/error-state-matcher';
import { AlertType } from '../alert/alert.component';


@Component({
    selector: 'app-message-box',
    templateUrl: './message-box.component.html',
    styleUrls: ['./message-box.component.scss']
})


export class MessageBoxComponent implements OnInit {
    @Input() errorStateMatcher: LsnErrorStateMatcher;
    @Input() type: AlertType = AlertType.ALERT_DANGER;

    constructor() {
    }

    getAlertType(type) {
        console.log(typeof type);
        return JSON.stringify(type);
    }

    ngOnInit(): void {
    }
}
